import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../apiCalls/rtkBaseQuery';
import { LIST_EBOOKS } from '../../../apiCalls/urls/eBooks';
import { GET_LIST } from '../../../apiCalls/urls/common';
export const eBookApi = createApi({
    baseQuery,
    tagTypes: ['eBook'],
    reducerPath: 'eBookApi',
    endpoints: (builder) => ({
        getEbookList: builder.query({
            query: (bodyData) => ({
                url: LIST_EBOOKS,
                method: 'POST',
                body: bodyData || {}
            }),
            providesTags: ['eBook'],
            refetchOnMountOrArgChange: true,
        }),
        getList: builder.mutation({
            query: (bodyData) => ({
                url: GET_LIST,
                method: 'POST',
                body: bodyData || {}
            }),
            refetchOnMountOrArgChange: false,
        })
    }),
});

export const {
    useGetEbookListQuery,
    useGetListMutation
} = eBookApi;